import React from 'react';
import { translate } from 'react-multi-lang';
import {
  Container,
  Button,
  Segment,
} from 'semantic-ui-react';

import ResponsiveContainer from '../../components/containers/ResponsiveContainer';
import PageHeader from '../../components/headers/PageHeader';
import useScrollTopOnMount from '../../logic/ui/useScrollTopOnMount';

import bgName from '../../img/bg/bourse-bg.jpg';

import reglement from '../../files/andjce-bourses-au-mérite-règlement.pdf'
import form from '../../files/andjce-formulaire-candidature-bourse.pdf'

const BoursePage = ({ t }) => {
  useScrollTopOnMount();
  return (
    <ResponsiveContainer
      minHeight={300}
      bgName={bgName}
      header={
        <PageHeader
          header="bourse"
        />
      }
    >
      <Container className="padded" text>
        <p>
          {t('humanitiesAwardText1')}
          <a href="http://www.andjce.com/">
            {t('andjceWebsiteUrl')}
          </a>
          {t('humanitiesAwardText3')}
          <br />
          <br />
          {t('bourseText1')}
          <br />
          <br />
          {t('bourseText2')}
        </p>
        <Segment basic textAlign="center">
          <Button
            size="huge"
            color="red"
          >
            <a
              download
              className="color-white"
              href={form}
            >
            {t('humanitiesAwardText13')}
            </a>
          </Button>
          <Button
            size="huge"
            basic
            color="red"
          >
            <a
              download
              className="color-red"
              href={reglement}
            >
            {t('humanitiesAwardText12')}
            </a>
          </Button>
        </Segment>
      </Container>
    </ResponsiveContainer>
  );
};

export default translate(BoursePage);
